export default {
  getSelectedUnit: (state) => {
    return {
      id: state.sales_unit_id,
      name: state.fields.sales_unit || ' ',
      label: state.fields.sales_unit || ' ',
    }
  },

  getBrand: (state) => {
    return state.fields.brand;
  },

  getWithDownPayment: (state) => {
    return state.fields.with_down_payment;
  },

  getUpdatePrice: (state) => {
    return state.update_price;
  },

  getWithDownPaymentCondition: (state) => {
    if (state.fields.with_down_payment) {
      return 'com entrada';
    }
    return 'sem entrada';
  },

  getPaymentTypeId: (state) => {
    return state.fields.payment_type_id;
  },

  getPaymentTypes: (state) => {
    return state.payment_types;
  },

  getSelectedDepartment: (state) => {
    return {
      id: state.department_id,
      name: state.fields.departament || ' ',
      label: state.fields.departament || ' ',
    }
  },

  getSelectedProduct: (state) => {
    return {
      id: state.product_id,
      integration_code: state.fields.integration_code,
      unit: {
        id: state.sales_unit_id,
        name: state.fields.sales_unit,
        label: state.fields.sales_unit,
      },
      department: {
        id: state.department_id,
        name: state.fields.departament,
        label: state.fields.sales_unit,
      },
      barcode: state.fields.barcode,
      qrcode: state.fields.qr_code,
      price: state.fields.value_cash,
      price2: state.fields.value_cash2,
      price3: state.fields.value_cash3,
      value_bundle: state.fields.value_bundle,
      discount_bundle: state.fields.discount_bundle,
      old_price: state.fields.old_price,
      value_old: state.fields.value_old,
      reduced_value: state.fields.reduced_value,
      label: state.fields.product_code || ' ',
      code: state.fields.product_code || ' ',
      main_description: state.fields.main_description,
      main_description2: state.fields.main_description2,
      main_description3: state.fields.main_description3,
      minor_description: state.fields.minor_description,
      minor_description2: state.fields.minor_description2,
      minor_description3: state.fields.minor_description3,
      simple_description: state.fields.simple_description,
      simple_description2: state.fields.simple_description2,
      simple_description3: state.fields.simple_description3,
      simple_description4: state.fields.simple_description4,
      simple_description5: state.fields.simple_description5,
      reoperated_product: state.fields.reoperated_product,
      product_other_sizes: state.fields.product_other_sizes,
      product_other_colors: state.fields.product_other_colors,
      product_comments: state.fields.product_comments,
      product_evaluation: state.fields.product_evaluation,
      product_material: state.fields.product_material,
      product_depth: state.fields.product_depth,
      product_height: state.fields.product_height,
      product_width: state.fields.product_width,

      brand: state.fields.brand,
      retail_packaging: state.fields.retail_packaging,
      wholesale_packing: state.fields.wholesale_packing,
      big_packing: state.fields.big_packing,
      validation: state.fields.validation,
      retail_taxation: state.fields.retail_taxation,
      wholesale_taxation: state.fields.wholesale_taxation,
      big_taxation: state.fields.big_taxation,
      light_taxation: state.fields.light_taxation,
      retail_media: state.fields.retail_media,
      wholesale_media: state.fields.wholesale_media,
      big_media: state.fields.big_media,
      light_media: state.fields.light_media,
      big_price: state.fields.big_price,
      light_price: state.fields.light_price,
      light_quantity: state.fields.light_quantity,

      free_text: state.fields.free_text,
      free_text2: state.fields.free_text2,
      free_text3: state.fields.free_text3,
      unit_proportional: state.fields.unit_proportional,
      ibm_code: state.fields.ibm_code,
      warranty: state.fields.warranty,
      assembly: state.fields.assembly,
    }
  },

  getPromotionalProduct: (state) => {
    return {
      id: state.promotion_product_id,
      promotion_unit: state.promotion_unit,
      unit2: {
        id: state.promotion_unit2_id,
        name: state.fields.promotion_unit2,
      },
      price: state.fields.promotional_product_value,
      code: state.fields.promotion_product || ' ',
      main_description: state.fields.promotion_main_description,
      minor_description: state.fields.promotion_minor_description,
    }
  },

  getTheme: (state) => {
    return state.theme_id;
  },

  getInitialContent: (state) => {
    return state.initial_content;
  },

  field: (state) => {
    return (field) => state.fields[field];
  },
  
  getInsertExpirationDates: (state) => {
    return state.insertExpirationDates;
  },

  getInsertProportionalValueInline: (state) => {
    return state.insertProportionalValueInline;
  },

  getInsertProductProportionalValueInline: (state) => {
    return state.insertProductProportionalValueInline;
  },

  getInsertProductExpirationDates: (state) => {
    return state.insertProductExpirationDates;
  },

  getInsertProductOlder: (state) => {
    return state.insertProductOlder;
  },

  getProportionalMeasureValue: (state) => {
    switch (state.fields.proportional_measure) {
      case 'Quilograma':
      case 'Litro':
        return 1000;
      case 'Centímetro':
        return 100;
      default:
        return 0;
    }
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/store/poster/getters.js